/** Airport-only calibrated gain trims. Native Chromium, 48 kHz, protection off.
 * Base calibration: python3 scripts/airport-feel-qa.py --calibrate
 * Final stress-headroom reductions: audit/airport-revision-2/headroom-adjustments.json
 * See audit/airport-revision-2/ for raw and independent signal-validation renders. */
export const AIRPORT_LEVELS: Readonly<Record<string, number>> = {
  "apt-agent-typing-frantic": 9.09388,
  "apt-agent-typing-long": 9.88955,
  "apt-agent-typing-short": 9.17296,
  "apt-aircraft-door": 5.54171,
  "apt-all-clear": 3.52663,
  "apt-amb-apron": 1.87246,
  "apt-amb-baggage": 1.10742,
  "apt-amb-cabin": 1.53072,
  "apt-amb-construction": 1.79344,
  "apt-amb-curbside": 1.2472,
  "apt-amb-day": 2.63541,
  "apt-amb-food-court": 3.19431,
  "apt-amb-gate": 3.60492,
  "apt-amb-jet-engine": 1.32418,
  "apt-amb-night": 1.92737,
  "apt-amb-rail": 3.34469,
  "apt-amb-security": 2.15125,
  "apt-amb-storm": 1.07026,
  "apt-amb-terminal": 2.3413,
  "apt-amb-tower": 3.24717,
  "apt-amb-vip-lounge": 3.92515,
  "apt-ambulance": 2.10737,
  "apt-applause-small": 9.53288,
  "apt-apron-bus": 1.84053,
  "apt-apu": 0.67007,
  "apt-auto-door-close": 3.12622,
  "apt-auto-door-open": 3.14848,
  "apt-autopilot-disconnect": 2.0419,
  "apt-baby-cry": 1.58114,
  "apt-baby-fuss": 2.14579,
  "apt-bag-drop-carousel": 4.43845,
  "apt-bag-overweight": 1.67002,
  "apt-bag-scale": 2.80407,
  "apt-bag-tag": 9.88866,
  "apt-bag-thud": 4.6747,
  "apt-baggage-tug-pass": 4.17611,
  "apt-bankruptcy-warning": 5.55315,
  "apt-bar-glasses": 2.16231,
  "apt-beer-pour": 8.01241,
  "apt-belt-loader": 3.94526,
  "apt-belt-send": 2.85089,
  "apt-bill-due": 10.52402,
  "apt-bin-empty": 9.74123,
  "apt-bird-strike": 2.14356,
  "apt-bizjet-takeoff": 0.82296,
  "apt-boarding-pass-print": 10.15555,
  "apt-body-scanner": 2.70852,
  "apt-budget-warning": 3.94094,
  "apt-build-blueprint": 34.79501,
  "apt-build-complete": 5.52017,
  "apt-build-concrete": 2.77275,
  "apt-build-crane": 3.15032,
  "apt-build-invalid": 17.10427,
  "apt-build-place": 6.01422,
  "apt-build-refund": 23.56656,
  "apt-build-rotate": 64.5881,
  "apt-build-runway-paint": 1.55051,
  "apt-build-snap": 54.43093,
  "apt-build-tile": 30.63748,
  "apt-build-upgrade": 5.58992,
  "apt-build-wall": 7.76724,
  "apt-build-zone": 7.36225,
  "apt-cabin-chime-hi": 1.85716,
  "apt-cabin-chime-hilo": 1.85716,
  "apt-cabin-chime-lo": 1.66885,
  "apt-cabin-pa-click": 38.84926,
  "apt-car-door": 5.81851,
  "apt-car-horn-long": 2.36838,
  "apt-car-horn-short": 3.57747,
  "apt-car-lock": 5.17798,
  "apt-car-trunk": 5.72269,
  "apt-card-chip-insert": 3.56795,
  "apt-card-swipe": 1.76254,
  "apt-card-swipe-fail": 1.20603,
  "apt-card-tap": 1.56102,
  "apt-cargo-door": 3.52452,
  "apt-cargo-loader": 3.57241,
  "apt-cargo-night": 1.01211,
  "apt-carousel-start": 2.10604,
  "apt-cash-drawer": 5.49048,
  "apt-catering-lift": 2.53882,
  "apt-coffee-machine": 2.41326,
  "apt-construct-drill": 5.40791,
  "apt-construct-hammer": 4.95783,
  "apt-construct-jackhammer": 3.44941,
  "apt-construct-reverse": 1.45556,
  "apt-construct-saw": 4.05672,
  "apt-container-clunk": 4.79315,
  "apt-contract-signed": 0.59974,
  "apt-cough": 2.81411,
  "apt-crowd-cheer": 2.15031,
  "apt-cutlery": 15.60948,
  "apt-deicing": 3.04858,
  "apt-demolish": 4.51136,
  "apt-desk-bell": 1.59195,
  "apt-desk-phone": 2.34062,
  "apt-detector-alarm": 1.60324,
  "apt-detector-pass": 2.46883,
  "apt-dog-bark": 2.8068,
  "apt-duty-free-bag": 30.19429,
  "apt-e-gate-open": 2.39967,
  "apt-elevator-ding": 1.96057,
  "apt-emergency-landing": 2.73946,
  "apt-emergency-lights": 43.77384,
  "apt-engine-fire-bell": 47.23166,
  "apt-engine-runup": 0.42983,
  "apt-engine-shutdown": 4.92035,
  "apt-engine-start": 4.22712,
  "apt-equipment-break": 3.49392,
  "apt-escalator-step": 3.4865,
  "apt-evacuation": 4.62142,
  "apt-expense-tick": 64.57407,
  "apt-fire-alarm": 2.10042,
  "apt-fire-tender": 2.16518,
  "apt-flight-arrived": 1.78313,
  "apt-flight-cancelled": 1.82539,
  "apt-flight-delayed": 3.67997,
  "apt-flight-departed": 1.97834,
  "apt-food-tray": 6.13574,
  "apt-footstep-carpet": 9.51132,
  "apt-footstep-tile": 10.86362,
  "apt-forklift": 1.98264,
  "apt-fryer": 0.66517,
  "apt-fuel-price-down": 9.2933,
  "apt-fuel-price-up": 9.3474,
  "apt-fuel-truck": 3.46759,
  "apt-galley-cart": 8.41182,
  "apt-gate-assigned": 9.30304,
  "apt-gear-down": 2.2625,
  "apt-generator-start": 2.15515,
  "apt-go-around": 0.75316,
  "apt-gpu-hum": 1.19715,
  "apt-groan": 1.52267,
  "apt-grumble-crowd": 3.23021,
  "apt-grumble-high": 2.03033,
  "apt-grumble-long": 2.31884,
  "apt-grumble-low": 2.49191,
  "apt-hail": 17.78102,
  "apt-hand-dryer": 1.8569,
  "apt-helicopter-pass": 3.14536,
  "apt-hmm": 1.80448,
  "apt-huff": 3.22359,
  "apt-hurry-steps": 4.0293,
  "apt-ils-ident": 1.63013,
  "apt-income-tick": 42.87687,
  "apt-inner-marker": 2.54607,
  "apt-janitor-mop": 15.88704,
  "apt-jet-flyby": 1.07008,
  "apt-jet-flyover-low": 2.28139,
  "apt-jet-landing": 0.73599,
  "apt-jet-takeoff": 0.9098,
  "apt-jet-taxi-pass": 4.23746,
  "apt-jetbridge-dock": 3.1696,
  "apt-key-solid": 13.22542,
  "apt-key-solid-enter": 16.12996,
  "apt-key-solid-space": 14.42653,
  "apt-kids-giggle": 2.21185,
  "apt-kiosk-tap": 5.6923,
  "apt-laugh": 2.59291,
  "apt-lav-truck": 5.77009,
  "apt-lavatory-flush": 2.14327,
  "apt-lightning-warning": 3.13084,
  "apt-loan-repaid": 7.97914,
  "apt-loan-taken": 4.91042,
  "apt-lockdown": 4.35796,
  "apt-loss-day": 7.41388,
  "apt-lost-luggage": 2.2372,
  "apt-marshaller-whistle": 7.49266,
  "apt-massage-chair": 2.97117,
  "apt-master-caution": 1.56147,
  "apt-medical-call": 5.41364,
  "apt-middle-marker": 1.33456,
  "apt-milestone": 1.14426,
  "apt-money-earned": 6.16666,
  "apt-money-spent": 38.34805,
  "apt-near-miss": 2.92749,
  "apt-new-day": 1.9279,
  "apt-notify": 3.67822,
  "apt-order-bell": 1.96066,
  "apt-out-of-order": 2.20542,
  "apt-outer-marker": 1.19251,
  "apt-overhead-bin-close": 4.66481,
  "apt-pa-announcement": 2.35721,
  "apt-pa-chime-2": 1.70071,
  "apt-pa-chime-3": 1.66299,
  "apt-pa-chime-4": 1.97525,
  "apt-pa-chime-end": 1.49346,
  "apt-parking-barrier": 4.53691,
  "apt-parking-ticket": 8.14122,
  "apt-passenger-angry": 6.64736,
  "apt-passenger-happy": 6.60482,
  "apt-passport-stamp": 5.37846,
  "apt-payment-approved": 1.34513,
  "apt-pigeon": 1.93518,
  "apt-pin-entry": 3.07044,
  "apt-pin-key": 4.39801,
  "apt-police-siren": 2.73191,
  "apt-power-outage": 2.78376,
  "apt-profit-day": 6.48862,
  "apt-prop-plane-pass": 3.10178,
  "apt-pushback": 2.61282,
  "apt-quarterly-report": 10.04272,
  "apt-queue-warning": 3.11038,
  "apt-radio-chatter": 4.00643,
  "apt-radio-key": 37.02398,
  "apt-radio-readback": 4.25625,
  "apt-radio-squelch": 9.3807,
  "apt-rail-arrival": 2.43132,
  "apt-rail-departure": 2.93998,
  "apt-rail-doors": 3.61302,
  "apt-rating-down": 5.01972,
  "apt-rating-up": 5.32914,
  "apt-receipt-print": 11.37171,
  "apt-regional-takeoff": 0.80993,
  "apt-repair-done": 7.18386,
  "apt-repair-wrench": 9.01462,
  "apt-reverse-beeper": 1.34653,
  "apt-reverse-thrust": 0.72134,
  "apt-runway-cleared": 2.51042,
  "apt-runway-closed": 4.17329,
  "apt-runway-incursion": 1.98688,
  "apt-salaries-paid": 42.74681,
  "apt-scan-fail": 1.47665,
  "apt-scan-ok": 2.5771,
  "apt-seatbelt-click": 9.95566,
  "apt-security-breach": 4.41747,
  "apt-shop-door": 3.96788,
  "apt-shop-till": 2.5587,
  "apt-shuttle-bus": 2.22536,
  "apt-sigh": 2.43337,
  "apt-sink-tap": 6.06603,
  "apt-snowplow": 2.79366,
  "apt-soap": 10.67378,
  "apt-speed-down": 9.8317,
  "apt-speed-up": 10.36094,
  "apt-split-flap-single": 22.67112,
  "apt-split-flap-update": 20.57662,
  "apt-sprinklers": 2.25809,
  "apt-staff-break": 5.23821,
  "apt-staff-fired": 5.19772,
  "apt-staff-hired": 7.05604,
  "apt-staff-strike": 4.45362,
  "apt-staff-tired": 2.86578,
  "apt-stairs-truck": 5.14292,
  "apt-stapler": 7.38777,
  "apt-stinger-award": 0.77683,
  "apt-stinger-bankrupt": 0.75784,
  "apt-stinger-contract": 0.72437,
  "apt-stinger-milestone": 0.78271,
  "apt-stinger-victory": 0.76989,
  "apt-suitcase-drop": 4.54278,
  "apt-suitcase-roll": 4.17988,
  "apt-suitcase-zip": 13.48512,
  "apt-suspicious-bag": 4.24127,
  "apt-swipe-gate": 2.34719,
  "apt-tax-paid": 8.62479,
  "apt-taxi-pass": 2.81196,
  "apt-thunder-close": 3.36255,
  "apt-thunder-distant": 2.89988,
  "apt-toilet-flush": 2.23172,
  "apt-touchdown-chirp": 8.05846,
  "apt-tower-alert": 1.69195,
  "apt-travelator-end": 2.40082,
  "apt-tray-slide": 14.78108,
  "apt-tray-stack": 5.88417,
  "apt-tray-table": 19.20494,
  "apt-trolley-push": 6.0448,
  "apt-trolley-stack": 4.5701,
  "apt-tsk": 13.26096,
  "apt-tug-horn": 2.42597,
  "apt-turboprop-flyby": 2.52448,
  "apt-turboprop-takeoff": 2.59039,
  "apt-ui-back": 15.3586,
  "apt-ui-cancel": 3.88773,
  "apt-ui-click": 26.52649,
  "apt-ui-click-soft": 49.54332,
  "apt-ui-confirm": 5.81443,
  "apt-ui-dialog": 4.06821,
  "apt-ui-drag": 19.72441,
  "apt-ui-drop": 20.5624,
  "apt-ui-hover": 56.51417,
  "apt-ui-invalid": 5.3764,
  "apt-ui-menu-close": 26.07054,
  "apt-ui-menu-open": 12.36529,
  "apt-ui-panel-in": 31.28797,
  "apt-ui-panel-out": 30.62171,
  "apt-ui-pause": 6.9438,
  "apt-ui-play": 6.70745,
  "apt-ui-save": 6.73315,
  "apt-ui-scroll": 79.84699,
  "apt-ui-select": 8.67988,
  "apt-ui-slider": 54.69152,
  "apt-ui-tab": 47.22707,
  "apt-ui-text": 70.45435,
  "apt-ui-toggle-off": 20.99162,
  "apt-ui-toggle-on": 19.13888,
  "apt-ui-tooltip": 12.61465,
  "apt-ui-zoom-in": 26.28026,
  "apt-ui-zoom-out": 23.80035,
  "apt-vending-drop": 3.75382,
  "apt-walkie-talkie": 3.11103,
  "apt-wand-beep": 1.82974,
  "apt-water-truck": 5.98999,
  "apt-weather-warning": 4.42086,
  "apt-widebody-takeoff": 1.02587,
  "apt-wind-gust": 4.70072,
  "apt-window-shade": 30.84455,
  "apt-xray-belt": 3.13343,
  "apt-yawn": 1.7707,
};
